export default "__VITE_ASSET__iprvFglS__"